// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
// Other dark themes: twilight, tomorrow, okaidia

import "prismjs/themes/prism.css"

require("prismjs/plugins/line-numbers/prism-line-numbers.css")

